export default __webpack_public_path__ + "static/media/ic_clear.167feef1.svg";